"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateLayout = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));

var _reactImageAndBackgroundImageFade = require("react-image-and-background-image-fade");

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.inline-components"));

var _gerenciatdUnifiedcomponents4 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.button"));

var _gerenciatdUnifiedcomponents5 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedcomponents6 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.carousel3-d"));

var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.constants");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

var _gerenciatdUnifiedcomponents7 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.info-list"));

var _gerenciatdUnifiedicons = _interopRequireDefault(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

require("./TresdSlider.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const translateLayout = layout => {
  return layout === 'futbol' || layout === 'futbol1' ? 'fútbol' : layout;
};

exports.translateLayout = translateLayout;

class TVslider extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "componentDidMount", () => {
      const {
        heightResizable,
        minHeight
      } = this.state;

      if (heightResizable) {
        let finalMinHeight = minHeight;
        setTimeout(() => {
          const elements = document.getElementsByClassName('infoCard');

          if (elements && elements.length > 0) {
            for (let i = 0; i < elements.length; i += 1) {
              const infoCard = elements[i];
              const infoCardHeight = infoCard && infoCard.offsetHeight || 0;

              if (infoCardHeight > minHeight - 200) {
                finalMinHeight = minHeight + 60;
              }
            }
          }

          this.setState({
            minHeight: finalMinHeight
          });
        }, 1000);
      }
    });

    _defineProperty(this, "getProperlyBackgroundSrc", bgImage => {
      const {
        device
      } = this.state;

      switch (device) {
        case _gerenciatdUtils.DEVICES.PC:
          return bgImage.picDesktop;

        case _gerenciatdUtils.DEVICES.TABLET:
          return bgImage.picTablet;

        default:
          return bgImage.picMobile;
      }
    });

    _defineProperty(this, "renderSlides", slides => {
      const {
        minHeight
      } = this.state; // const { SvgIconLoader } = this.props;

      const finalSlides = [];
      slides.forEach(slide => {
        let {
          layout
        } = slide;
        layout = layout ? layout.toLowerCase() : 'info';
        const {
          bgImage,
          slideInfo
        } = slide;
        const idSlide = (0, _gerenciatdUtils2.generateComponentId)('tvSlide', 'home');
        const deviceBg = this.getProperlyBackgroundSrc(bgImage); // bannerBuildBGImg(bgImage, idSlide, 'full', bgImage.bgColor);

        const currentSlide = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageAndBackgroundImageFade.BackgroundImage, {
          src: deviceBg.src,
          width: "100px",
          height: "100px",
          wrapperClassName: "bgItem",
          isResponsive: true,
          style: {
            minHeight: `${minHeight}px`
          },
          lazyLoad: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            id: idSlide,
            className: "bgItem-sub",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: `screen screen--${layout}`,
              children: [layout && layout !== 'info' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: `layoutName layoutName--${layout}`,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
                  align: "center",
                  kind: "heading",
                  className: "layoutName_title",
                  color: _gerenciatdUnifiedcomponents.COLOR.WHITE,
                  level: 4,
                  headingType: _gerenciatdUnifiedcomponents.SIZE.TITLE4,
                  text: translateLayout(layout)
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: `infoCard infoCard--${layout}`,
                children: [slideInfo && slideInfo['image-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, slideInfo['image-1']), {}, {
                  className: "img_slider"
                })), slideInfo && slideInfo['infoText-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, slideInfo['infoText-1']), {}, {
                  className: "title_card"
                })), slideInfo && slideInfo['infoText-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, slideInfo['infoText-2'])), slideInfo && slideInfo['infoText-3'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, slideInfo['infoText-3'])), slideInfo && slideInfo['infoText-4'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, slideInfo['infoText-4'])), slideInfo && slideInfo['infoText-5'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, slideInfo['infoText-5'])), slideInfo && slideInfo['infoList-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents7.default, _objectSpread(_objectSpread({}, slideInfo['infoList-1']), {}, {
                  SvgIconLoader: _gerenciatdUnifiedicons.default
                })), slideInfo && slideInfo['inlineComponents-1'] && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents3.default, {
                  children: [slideInfo['inlineComponents-1']['button-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, _objectSpread({
                    size: {
                      w: _gerenciatdUnifiedcomponents4.BUTTON_WIDTH.FULL
                    }
                  }, slideInfo['inlineComponents-1']['button-1'])), slideInfo['inlineComponents-1']['button-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, _objectSpread({
                    size: {
                      w: _gerenciatdUnifiedcomponents4.BUTTON_WIDTH.FULL
                    }
                  }, slideInfo['inlineComponents-1']['button-2']))]
                }), slideInfo && slideInfo['button-1'] && !slideInfo['svgIconLabel-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, _objectSpread({
                  size: {
                    w: _gerenciatdUnifiedcomponents4.BUTTON_WIDTH.FULL
                  }
                }, slideInfo['button-1'])), slideInfo && slideInfo['button-1'] && slideInfo['svgIconLabel-1'] && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "row butonSvgContainer",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "col-sm-6 col-xs-6",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread(_objectSpread({
                      id: slideInfo['svgIconLabel-1'].svgId
                    }, slideInfo['svgIconLabel-1']), {}, {
                      size: 25,
                      kind: "S",
                      color: "white"
                    }))
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "col-sm-6 col-xs-6",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, _objectSpread({
                      size: {
                        w: _gerenciatdUnifiedcomponents4.BUTTON_WIDTH.FULL
                      }
                    }, slideInfo['button-1']))
                  })]
                })]
              }), layout && layout === 'info' && slideInfo && slideInfo['customLink-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, slideInfo['customLink-1']), {}, {
                isBlockElement: true
              }))]
            })
          })
        });
        finalSlides.push(currentSlide);
      });
      return finalSlides;
    });

    const {
      minHeight: _minHeight,
      heightResizable: _heightResizable
    } = props;

    const _device = (0, _gerenciatdUtils2.getDeviceKindDependsOnViewPort)();

    const data = props;
    this.state = {
      error: false,
      data,
      device: _device,
      minHeight: _minHeight,
      heightResizable: _heightResizable
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      error: true
    });
    console.log('error: ', error);
    console.log('info: ', info);
  }

  render() {
    const {
      data,
      minHeight,
      error
    } = this.state;

    if (error) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: "ERROR DETECTADO"
      });
    }

    const {
      bgColor,
      title,
      slides,
      taggingInfo: firstLevelTaggingInfo
    } = data;
    const cssBgColor = bgColor ? ` tvSliderContainer_bg--${bgColor}` : ' tvSliderContainer_bg--blue';
    const slidesInfoRendered = this.renderSlides(slides);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `tvSliderContainer ${cssBgColor}`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        className: "slider_title",
        color: _gerenciatdUnifiedcomponents.COLOR.WHITE,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.HEADING,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.THIN,
        align: "center",
        level: 3,
        size: _gerenciatdUnifiedcomponents.SIZE.TITLE2,
        text: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
          className: "tvSliderCarousel",
          minHeight: minHeight,
          slides: slidesInfoRendered,
          taggingInfo: firstLevelTaggingInfo,
          minimunSpace: 50
        })
      }), data && data['button-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "tvSliderContainer_buttonContainer",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "col-sm-3 col-xs-12",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, _objectSpread(_objectSpread({}, data['button-1']), {}, {
            size: {
              w: 'full'
            },
            className: "buttonTVSlider"
          }))
        })
      })]
    });
  }

}

TVslider.WaitingComponent = () => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
  className: "configFake tvSlider",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
    count: 1,
    height: 350,
    width: "80%"
  })
});

TVslider.propTypes = {
  minHeight: _propTypes.default.number,
  heightResizable: _propTypes.default.bool
};
TVslider.defaultProps = {
  minHeight: 400,
  heightResizable: true
};
var _default = TVslider;
exports.default = _default;

//# sourceMappingURL=index.js.map